import {useTranslation} from 'react-i18next';
import {TriangleAlertIcon, CheckIcon} from 'lucide-react';
import {cn} from '@chekin/guestapp-ui-kit';

type props = {
  completed: boolean;
  className?: string;
  texts?: {
    completed?: string;
    incomplete?: string;
  };
};

function StatusText({completed, className, texts}: props) {
  const {t} = useTranslation();

  const completedText = texts?.completed || t('completed');
  const incompleteText = texts?.incomplete || t('incomplete');
  const statusText = completed ? completedText : incompleteText;

  return (
    <>
      <div
        className={cn(
          'flex items-center w-full  font-bold text-sm leading-6 nav-item__status',
          !completed ? 'text-[var(--status-warning)]' : 'text-[var(--status-success)]',
          'kiosko:text-kiosko-xs kiosko:font-semibold kiosko:gap-2',
          className,
        )}
      >
        {completed ? (
          <CheckIcon
            size={16}
            className={cn('mr-1 nav-item__check-icon', 'kiosko:w-8 kiosko:h-8')}
            data-testid="status-icon"
          />
        ) : (
          <TriangleAlertIcon
            size={16}
            className={cn(
              'mr-1 ',
              'kiosko:w-9 kiosko:h-9',
              '[&>*:first-child]:fill-current',
              '[&>*:first-child]:stroke-transparent',
              '[&>*:not(:first-child)]:stroke-white nav-item__warning-icon',
            )}
            data-testid="status-icon"
          />
        )}
        {statusText}
      </div>
    </>
  );
}

export {StatusText};
